export const MIN_FADE_DURATION = 1000;
export const FADE_INTERVAL = 10;
